module.exports = __webpack_public_path__ + "img/experience.936ebc26.svg";